module.exports = __webpack_public_path__ + "img/icon_call@2x.209d0469.png";